import React, { useEffect, useRef, useState } from "react";
import { Popup } from "semantic-ui-react";
import FilterBox from "../Assesment/Filter_Box/FilterBox";
import SortedBy from "../Assesment/Filter_Box/SortedBy";
import "./Assesment.css";
import OnreviewAss from "./Onreview/OnreviewAss";
import CompletedAss from "./Completed/CompletedAss";
import PendingAss from "./Pending/PendingAss";
import { useSelector } from "react-redux";
import axios from "../../axios";
import moment from "moment";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import AssessmentTour from "../../SidebarHeader/Header/AssessmentTour";
// some css comes from HomeWorkMain.css

export default function AssesmentMain() {
  const popupRef = useRef(null);
  const subMenu = localStorage.getItem("assessSubMenu")
  const [homeMain, setHomeMain] = useState({
    subMenu: subMenu || "pending",
    assessmentData: null,
    AssessmentpendingSubDetail: false,
    AssessmentOnReviewSubDetail: false,
    AssessmentCompletedSubDetail: false,
  });
  const [isSortPopupOpen, setIsSortPopupOpen] = useState(false);
  const [isPopupOpenFilter, setIsPopupOpenFilter] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupAssessment");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupAssessment", "true");
    }
  }, []);
  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Digital.Class' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".digitalClass",
      intro: `
        <h3>Digital.Class</h3>
        <p>Digital.Class has 2 features (as shown in left most pane):
       </p>
       <ol>
          <li>Summary</li>
          <li>Assessment</li>
           <li>Self Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneDC",
      intro: `
        <h3>Features Group Left Pane
        Digital.Class has 3 features as shown:</h3>
        <ol>
        <li>Summary</li>
        <li>Assessment</li>
        <li>Self Assessment</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".assessment",
      intro: `
        <h3>Assessment</h3>
        <p>Currently 'Assessment' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsAssessment",
      intro: `
        <h3>Today and Other Assessments</h3>
        <p>You can see assessmments under today and other section.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingAssessment",
      intro: `
        <h3>Upcoming</h3>
        <p>In this tab you will find Assessments which needs to be submitted by you.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".reviewAssessments",
      intro: `
        <h3>On Review</h3>
        <p>You will find your submitted assessments which are yet to be reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedAssessment",
      intro: `
        <h3>Completed</h3>
        <p>You will find your submitted assessments which are reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".filterAssessment",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject time and date wise.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByAssessment",
      intro: `
        <h3>Sort By</h3>
        <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };

  const [rotation, setRotation] = useState(0);

  const rotateImage = () => {
    setRotation((rotation) => rotation + 180);
  };

  const togglePopup = () => {
    setIsSortPopupOpen(!isSortPopupOpen);
  };

  const togglePopupFilter = () => {
    // setIsPopupOpenFilter(!isPopupOpenFilter);
    setIsPopupOpenFilter((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpenFilter(false);
      }
    };

    if (isPopupOpenFilter) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpenFilter]);

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 20,
    page: 1,
  });

  return (
    <div className="AssSubContainer h-100 relative">
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div className="d-flex justify-between">
        <div className="d-flex mt-3 col-3 p-0 HomeWorkSubPartsMenuTotal">
          <div
            className={
              homeMain.subMenu === "pending"
                ? "HomeWorkSubPartsMenuActive pendingAssessment"
                : "HomeWorkSubPartsMenu pendingAssessment"
            }
            onClick={() => { setHomeMain({ subMenu: "pending" }); localStorage.setItem("assessSubMenu", "pending") }}
          >
            Upcoming
          </div>

          <div
            className={
              homeMain.subMenu === "review"
                ? "HomeWorkSubPartsMenuActive  d-flex justify-content-center mr-2 reviewAssessments"
                : "HomeWorkSubPartsMenu d-flex justify-content-center mr-2 reviewAssessments"
            }
            onClick={() => { setHomeMain({ subMenu: "review" }); localStorage.setItem("assessSubMenu", "review") }}
          >
            On Review
          </div>
          <div
            // className='HomeWorkSubPartsMenu d-flex justify-content-center'
            className={
              homeMain.subMenu === "Completed"
                ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedAssessment"
                : "HomeWorkSubPartsMenu d-flex justify-content-center completedAssessment"
            }
            onClick={() => { setHomeMain({ subMenu: "Completed" }); localStorage.setItem("assessSubMenu", "Completed") }}
          >
            Completed
          </div>
        </div>
        {/* <div className="col-1"></div> */}
        <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
          <div className="mb-3 filterAssessment">
            <div onClick={togglePopupFilter} className="col-md-12 gap-2 filter_box">
              <img
                className="filter_icon"
                src="/HwImg/filter Icon.svg"
                alt=""
              />
              <span>Filter</span>
            </div>
            {/* <Popup
              open={isPopupOpenFilter}
              onClose={togglePopupFilter}
              onOpen={togglePopupFilter}
              on="click"
              className="popUpFilter_ass"
              trigger={
                <div className="col-md-12 gap-2 filter_box">
                  <img
                    className="filter_icon"
                    src="/HwImg/filter Icon.svg"
                    alt=""
                  />
                  <span>Filter</span>
                </div>
              }
              content={ }
              position="bottom center"
            /> */}
          </div>
          <div
            className="d-flex gap-2 align-items-center  mb-3 sortByAssessment"
            style={{ cursor: "pointer" }}
            onClick={() => {
              togglePopup()
              rotateImage()
            }}
          >
            <div className="sortby">Sort by</div>
            <div>
              <img
                src="/HwImg/DownArrowSort.png"
                alt=""
                style={{ transform: `rotate(${rotation}deg)` }}
              ></img>
            </div>
          </div>

          {/* <Popup
            on="click"
            open={isPopupOpen}
            onClose={togglePopup}
            onOpen={togglePopup}
            className="popUpFilter_ass"
            trigger={

            }
            content={<SortedBy filter={filter} setFilter={setFilter} togglePopup={togglePopup} />}
            position="bottom center"
          /> */}
        </div>
      </div>

      <div className="AssementPendingComplReviewContainer CardsAssessment orange-scrollBar">
        {homeMain.subMenu === "pending" && (
          <PendingAss
            setFilter={setFilter}
            filter={filter}
            setHomeMain={setHomeMain}
          />
        )}
        {homeMain.subMenu === "Completed" && (
          <CompletedAss
            setFilter={setFilter}
            filter={filter}
            setHomeMain={setHomeMain}
          />
        )}
        {homeMain.subMenu === "review" && (
          <OnreviewAss
            setFilter={setFilter}
            filter={filter}
            setHomeMain={setHomeMain}
          />
        )}
      </div>
      {homeScreenWalkThroughPopup && (
        <AssessmentTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {
        isPopupOpenFilter && (
          <div ref={popupRef}>
            <FilterBox setFilter={setFilter} filter={filter} togglePopup={togglePopupFilter} />
          </div>
        )
      }
      {
        isSortPopupOpen && <SortedBy filter={filter} setFilter={setFilter} togglePopup={togglePopup} />
      }
    </div>
  );
}
